import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image'
import Sheets from '../UploadXlsx'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const AddProductForm = ({
  newProductFormData,
  handleNewProductChange,
  handleAddProductFormSubmit,
  setShowAddForm,
  categories,
  filters,
  imageSetOpenDialog,
  token,
  setNewProductFormData,
  showAddForm

}) => {
  const [selectedFilter, setSelectedFilter] = useState('');
  const [openDialog, setOpenDialog] = useState(false);

  const isSlide = newProductFormData.type === 'slide';

  const handleFilterChange = (e) => {
    const selectedFilter = e.target.value;
    setSelectedFilter(selectedFilter);
    handleNewProductChange(e);
  };

  const formatWithTwoDecimals = (value) => {
    const strValue = value.toString().replace('.', '');
    const length = strValue.length;
    const formattedValue = `${strValue.slice(0, length - 2)}.${strValue.slice(length - 2)}`;
    return parseFloat(formattedValue).toFixed(2);
  };

  const handleNumberChange = (e) => {
    const formattedValue = formatWithTwoDecimals(e.target.value);
    handleNewProductChange({ target: { name: e.target.name, value: formattedValue } });
  };

  const handleIntegerChange = (e) => {
    handleNewProductChange({ target: { name: e.target.name, value: e.target.value } });
  };

  const filteredCategories = categories.filter(cat => String(cat.filter) === String(selectedFilter));

  return (
    <Dialog
      open={showAddForm}
      onClose={() => setShowAddForm(false)}
      PaperProps={{
        style: {
          width: '600px',
          height: '80vh',
          maxWidth: 'none',
        },
      }}
    >
      <DialogTitle>Adicionar Produto</DialogTitle>
      <DialogContent>
        <form onSubmit={handleAddProductFormSubmit} className="add-product-form" style={{ width: '100%' }}>
          {/* <Button
        onClick={() => setOpenDialog(true)}
        style={{
          background: 'black',
          color: 'white',
          marginBottom: '1rem',
          border: "none",
          cursor: "pointer",
          padding: '.8rem 1.5rem',
          borderRadius: '.5rem'
        }}
      >
        Upload Sheet
      </Button> */}
          <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
            <DialogTitle>Upload Sheet</DialogTitle>
            <DialogContent className="dialog-content-hidden-scroll">
              <Sheets token={token} filters={filters} categories={categories} />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenDialog(false)} color="primary">
                Fechar
              </Button>
            </DialogActions>
          </Dialog>

          {/* ADDED: type selector */}
          <select
            name="type"
            value={newProductFormData.type}
            onChange={handleNewProductChange}
            required
            className="add-product-select"
          >
            <option value="product">Produto</option>
            <option value="slide">Slide</option>
          </select>

          <input
            type="text"
            name="name"
            value={newProductFormData.name}
            onChange={handleNewProductChange}
            placeholder="Nome do Produto"
            required
            className="add-product-input"
          />

          <select
            name="filter"
            value={selectedFilter}
            onChange={handleFilterChange}
            required
            className="add-product-select"
          >
            <option value="">Selecione um Filtro</option>
            {filters.map((filter) => (
              <option key={filter.id} value={filter.id}>
                {filter.name}
              </option>
            ))}
          </select>

          {selectedFilter && (
            <select
              name="category"
              value={newProductFormData.category}
              onChange={handleNewProductChange}
              required
              className="add-product-select"
            >
              <option value="">Selecione uma Categoria</option>
              {filteredCategories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          )}

          <input
            name="order"
            value={newProductFormData.order}
            onChange={handleIntegerChange}
            placeholder="Ordem"
            required
            className="add-product-input"
          />

          {/* ADDED: only show product fields when not a slide */}
          {!isSlide && (
            <>
              <select
                name="group"
                value={newProductFormData.group}
                onChange={handleNewProductChange}
                required
                className="add-product-input"
                style={{ color: 'grey' }}
              >
                <option value="">Selecione o grupo</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="CB">CB</option>
              </select>
              <input
                type="text"
                name="price10x"
                value={newProductFormData.price10x}
                onChange={handleNumberChange}
                placeholder="Price 10x"
                required
                className="add-product-input"
              />
              <input
                type="text"
                name="price6x"
                value={newProductFormData.price6x}
                onChange={handleNumberChange}
                placeholder="Créd/Déb"
                required
                className="add-product-input"
              />
              <input
                type="text"
                name="price_pix"
                value={newProductFormData.price_pix}
                onChange={handleNumberChange}
                placeholder="Price PIX"
                required
                className="add-product-input"
              />
              <input
                type="text"
                name="desconto_maximo"
                value={newProductFormData.desconto_maximo}
                onChange={handleNumberChange}
                placeholder="Desconto Máximo"
                required
                className="add-product-input"
              />
              <input
                type="text"
                name="valor_maximo"
                value={newProductFormData.valor_maximo}
                onChange={handleNumberChange}
                placeholder="Valor Máximo"
                required
                className="add-product-input"
              />
              <div style={{ display: 'flex' }}>
                <input
                  type="text"
                  name="image_path"
                  value={newProductFormData.image_path.replace('img/', '')}
                  onChange={handleNewProductChange}
                  placeholder="Caminho da Imagem (nome)"
                  className="add-product-input"
                  style={{ width: '100%' }}
                />
                <IconButton onClick={() => imageSetOpenDialog(true)}>
                  <ImageIcon style={{ fontSize: '100%', height: '100%', fontSize: 'larger' }} />
                </IconButton>
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input
                  type="checkbox"
                  name="is_promotional"
                  checked={newProductFormData.is_promotional}
                  onChange={(e) =>
                    handleNewProductChange({
                      target: { name: 'is_promotional', value: e.target.checked },
                    })
                  }
                />
                Promocional
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input
                  type="checkbox"
                  name="is_trending"
                  checked={newProductFormData.is_trending}
                  onChange={(e) =>
                    handleNewProductChange({
                      target: { name: 'is_trending', value: e.target.checked },
                    })
                  }
                />
                Em Alta (Trending)
              </label>
            </>
          )}

          {/* ADDED: slide-specific fields */}
          {isSlide && (
            <>

              {(() => {
                const images = newProductFormData.images || [];
                return (
                  <div
                    className="image-upload-box"
                    onClick={() => imageSetOpenDialog(true)}
                    style={{
                      border: `2px dashed ${images.length > 0 ? '#1976d2' : '#bbb'}`,
                      borderRadius: 12,
                      padding: 16,
                      cursor: 'pointer',
                      transition: 'border-color 0.2s, background 0.2s',
                      background: images.length > 0 ? '#f0f7ff' : 'transparent',
                    }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = '#1976d2'}
                    onMouseLeave={e => e.currentTarget.style.borderColor = images.length > 0 ? '#1976d2' : '#bbb'}
                  >
                    {images.length === 0 ? (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, color: '#888' }}>
                        <ImageIcon style={{ fontSize: 40 }} />
                        <span style={{ fontSize: 14 }}>Clique para adicionar imagens do slide</span>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                          {images.map((img, i) => (
                            <div key={i} style={{ position: 'relative', width: 64, height: 64 }}>
                              <img
                                src={img.image_url}
                                alt={`slide-${i}`}
                                style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
                              />
                              <button
                                onClick={e => {
                                  e.stopPropagation();
                                  setNewProductFormData(prev => ({
                                    ...prev,
                                    images: prev.images.filter((_, idx) => idx !== i)
                                  }));
                                }}
                                style={{
                                  position: 'absolute', top: -6, right: -6,
                                  background: '#e53935', color: '#fff', border: 'none',
                                  borderRadius: '50%', width: 20, height: 20, fontSize: 12,
                                  cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}
                              >×</button>
                            </div>
                          ))}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#1976d2', fontSize: 13 }}>
                          <ImageIcon style={{ fontSize: 16 }} />
                          <span>{images.length} imagem{images.length > 1 ? 'ns' : ''} · clique para adicionar mais</span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })()}
            </>
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddProductFormSubmit}>Salvar</Button>
        <Button onClick={() => setShowAddForm(false)}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddProductForm;